import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ModalService } from 'src/app/apv/core/services/modal/modal.service';
import {
  CURRENCY,
  MODIFY_AMOUNT,
} from '../modify-amount/modify-amount.constants';
import { ICurrentSubscription } from 'src/app/shared/interfaces/subscription.interface';
import { toClp } from 'src/app/apv/core/utils/formatters';
import { ENABLE_CCV_CAV_ACCOUNT_DETAIL_GO_BACK_BTN } from 'src/app/shared/common/constants';
import { IonicStorageService } from 'src/app/apv/core/services/storage/ionic/storage.service';

@Component({
    selector: 'app-option-modify-modal',
    templateUrl: './option-modify-modal.component.html',
    styleUrls: ['./option-modify-modal.component.scss'],
    standalone: false
})
export class OptionModifyModalComponent implements OnInit {
  constructor(
    private readonly modalSvc: ModalService,
    private readonly router: Router,
    private readonly activatedRoute: ActivatedRoute,
    private readonly ionicStorage: IonicStorageService
  ) {}

  modifyAmount = MODIFY_AMOUNT;
  currency = CURRENCY;
  subscriptionDataToModify!: ICurrentSubscription;
  buttonsFocus = {
    regimen: false,
    amount: false,
  }

  ngOnInit(): void {
    this.getDataFromStorage();
  }

  savesBySubscription() {
    return this.currencyByAmountAndCurrencyCode(
      this.subscriptionDataToModify.discountValue,
      this.subscriptionDataToModify.discountType
    );
  }

  private currencyByAmountAndCurrencyCode(
    amount: number,
    currencyCode: string
  ) {
    switch (currencyCode) {
      case 'P':
        return `$ ${this.numberToCurrency(amount)}`;
      case 'U':
        return `${this.numberToCurrency(amount)} UF`;
      case 'R':
        return `${this.numberToCurrency(amount)} %`;
      default:
        return '';
    }
  }
  public unitModify() {
    switch (this.subscriptionDataToModify.discountType) {
      case 'U':
        return 'uf';
      case 'P':
        return 'pesos';
      case 'R':
        return 'porcentaje';
      default:
        return '';
    }
  }

  public numberToCurrency(number: number) {
    if (number) {
      const numberString = toClp(number);
      return numberString;
    }
    return '';
  }

  closeModal(): void {
    this.modalSvc.closeModal();
  }

  getDataFromStorage() {
    const subscriptionData = sessionStorage.getItem('subscriptionDataToModify');
    if (subscriptionData) {
      this.subscriptionDataToModify = JSON.parse(subscriptionData);
    }
  }

  closeOpenModal(): void {
    this.modalSvc.closeModal();
  }

  async openAmountModificationModal(): Promise<void> {
    this.router.navigate(['../modify'], { relativeTo: this.activatedRoute });
  }

  openRegimenModificationModal(): void {
    this.router.navigate(['../regime-modify'], {
      relativeTo: this.activatedRoute,
    });
  }
  async salir() {
    const goBackToDetail = await this.ionicStorage.get(ENABLE_CCV_CAV_ACCOUNT_DETAIL_GO_BACK_BTN);

    if(goBackToDetail){
      this.router.navigate(['/home/ccv/detail']);
      return;
    }

    this.router.navigate(['/home/ccv']);
  }
  onFocusButtonRegimen() {
    this.buttonsFocus.regimen = !this.buttonsFocus.regimen;
  }
  onFocusButtonAmount() {
    this.buttonsFocus.amount = !this.buttonsFocus.amount;
  }
}
